import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase, ensureProfile } from '../lib/supabase';

const AuthContext = createContext({});
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = new Promise((resolve) =>
      setTimeout(() => resolve({ data: { session: null } }), 5000)
    );
    Promise.race([supabase.auth.getSession(), timeout])
      .then(({ data: { session } }) => {
        setUser(session?.user ?? null);
      })
      .catch(() => {
        setUser(null);
      })
      .finally(() => {
        setLoading(false);
      });
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      setUser(session?.user ?? null);
      // Auto-create profile for Google (OAuth) sign-ins
      if (event === 'SIGNED_IN' && session?.user) {
        try { await ensureProfile(session.user); } catch (e) { console.error('ensureProfile:', e.message); }
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
